module.exports = "<div class=\"loading-spinner-wrapper\" *ngIf=\"active\">\n    <section class=\"loading-spinner\"></section>\n</div>\n"